import React from "react";
import { HiOutlineExternalLink } from "react-icons/hi";

const ProjectCard = ({ project, index }) => {
  return (
    <article className="project-card-view scroll-reveal">
      <div className="project-card-top">
        <span>{String(index + 1).padStart(2, "0")}</span>
        <p>{project.type}</p>
      </div>
      <h2>{project.title}</h2>
      <p className="project-description">{project.description}</p>
      <ul>
        {project.impact.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <a href={project.link} target="_blank" rel="noreferrer" className="project-link">
        View reference <HiOutlineExternalLink />
      </a>
    </article>
  );
};

export default ProjectCard;
